import React from 'react';
import { useSelector } from 'react-redux';
import { Store } from 'types/store';
import useViewport from 'utils/useViewportHelper';

const Banner = () => {
  const { isMobile } = useViewport();
  const { isEligibleForOneMonthFreeDiscount, discountModel } = useSelector((state: Store) => state.expiryRenewal.pageModel) ?? {};

  let message = '';
  if (isEligibleForOneMonthFreeDiscount && discountModel?.isDiscountedPrice) {
    message = `Renew today, save ${discountModel?.basketDiscountText} + get 1 month free`;
  } else if (isEligibleForOneMonthFreeDiscount && !discountModel?.isDiscountedPrice) {
    message = 'Renew today + get 1 month free';
  } else if (discountModel?.isDiscountedPrice) {
    message = `Renew today, save ${discountModel?.basketDiscountText}`;
  }

  return (
    <div className={`bg-orange text-white text-center ${!isMobile && 'rounded-top'}`}>
      <h5 className="lh-lg">{message}</h5>
    </div>
  );
};

export default Banner;
